import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

export default function AdminRoleDrilldownPage({ params }: PageProps) {
  const { id: role_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      <AdminManagement.Roles.Drilldown role_id={role_id} />
    </AdminManagement.Layout>
  );
}
